/**
 * High-performance account information hooks with minimal re-renders
 */

import { useAccountInformationStore } from '../stores/useAccountInformationStore';

// Main hook with individual selectors to avoid re-renders
export const useAccountInformation = () => {
  const account = useAccountInformationStore((state) => state.account);
  const loadingStatus = useAccountInformationStore((state) => state.loadingStatus);
  const errorMessage = useAccountInformationStore((state) => state.errorMessage);
  const lastUpdated = useAccountInformationStore((state) => state.lastUpdated);
  const getAccount = useAccountInformationStore((state) => state.getAccount);

  return {
    account,
    loadingStatus,
    errorMessage,
    lastUpdated,
    isComplete: loadingStatus === 'complete',
    hasAccount: account !== null,
    getAccount,
  };
};

// Loading status only (minimal re-renders)
export const useAccountInformationLoading = () => {
  const status = useAccountInformationStore((state) => state.loadingStatus);
  const errorMessage = useAccountInformationStore((state) => state.errorMessage);
  
  return { status, errorMessage };
};

/**
 * Investor (read-only) session flag. When true every trading control (order entry, BUY/SELL, close,
 * modify, SL/TP drag) must be hidden or disabled — the gateway refuses the command anyway.
 */
export const useIsInvestorAccount = () =>
  useAccountInformationStore((state) => state.account?.isInvestor === true);

/** Non-hook read for imperative paths (client send guards, agent tools). */
export const isInvestorAccount = () =>
  useAccountInformationStore.getState().account?.isInvestor === true;

export const INVESTOR_READ_ONLY_MESSAGE =
  'Investor (read-only) login: trading is disabled for this account';
